// src/features/modal/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isVisible: false,
  modalContent: null, // This will store dynamic content
  classes: "",
  title: ""
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal: (state, action) => {
      const { content, classes, title } = action.payload;
      state.isVisible = true;
      state.modalContent = content;
      state.classes = classes;
      state.title = title;
    },
    hideModal: (state) => {
      state.isVisible = false;
      state.modalContent = null;
      state.classes = "";
      state.title = "";
    }
  }
});

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer;
